import _defineProperty from "/runner/_work/miro-site/miro-site/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import animation from './animation';
import { designTokens } from '../design-tokens';
import { outlines } from './focus';
var sizes = {
  small: {
    borderRadius: 40,
    fontSize: 14,
    lineHeight: 20
  },
  medium: {
    borderRadius: 24,
    fontSize: 18,
    lineHeight: 24
  },
  large: {
    borderRadius: 40,
    fontSize: 24,
    lineHeight: 32
  },
  dsLg: {
    borderRadius: '999em',
    fontFamily: designTokens.fonts.secondary,
    fontWeight: '400',
    fontSize: 'var(--font-sizes-225)',
    lineHeight: '1.35',
    letterSpacing: '0em'
  },
  dsMd: {
    borderRadius: '999em',
    fontFamily: designTokens.fonts.secondary,
    fontWeight: '400',
    fontSize: 'var(--font-sizes-225)',
    lineHeight: '1.35',
    letterSpacing: '0em',
    textAlign: 'left'
  },
  dsSm: {
    fontFamily: designTokens.fonts.secondary,
    borderRadius: '999em',
    fontSize: 'var(--font-sizes-175)',
    lineHeight: '1.15'
  }
};
var dsCommonStyles = {
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  position: 'relative',
  top: '-1px'
};
var spacing = {
  small: {
    paddingLeft: 19,
    paddingRight: 19,
    paddingTop: 8,
    paddingBottom: 10
  },
  medium: {
    paddingLeft: 23,
    paddingRight: 23,
    paddingTop: 9,
    paddingBottom: 13
  },
  large: {
    paddingLeft: 31,
    paddingRight: 31,
    paddingTop: 13,
    paddingBottom: 17
  },
  dsLg: _objectSpread({
    paddingLeft: 'var(--space-300)',
    paddingRight: 'var(--space-300)',
    minHeight: '48px'
  }, dsCommonStyles),
  dsMd: _objectSpread({
    paddingLeft: 'var(--space-200)',
    paddingRight: 'var(--space-200)',
    minHeight: '40px'
  }, dsCommonStyles),
  dsSm: _objectSpread({
    paddingLeft: 'var(--space-100)',
    paddingRight: 'var(--space-100)',
    minHeight: '32px'
  }, dsCommonStyles)
};
var withArrowSpacing = {
  small: {
    paddingLeft: 19,
    paddingRight: 15,
    paddingTop: 8,
    paddingBottom: 10
  },
  medium: {
    paddingLeft: 23,
    paddingRight: 19,
    paddingTop: 9,
    paddingBottom: 13
  },
  large: {
    paddingLeft: 31,
    paddingRight: 21,
    paddingTop: 13,
    paddingBottom: 17
  },
  dsLg: _objectSpread(_objectSpread({
    paddingLeft: 'var(--space-300)',
    paddingRight: 'var(--space-300)',
    minHeight: '48px'
  }, dsCommonStyles), {}, {
    '&::after': {
      marginLeft: 'var(--space-offset-50)',
      fontSize: 'var(--font-sizes-300)'
    }
  }),
  dsMd: _objectSpread(_objectSpread({
    paddingLeft: 'var(--space-200)',
    paddingRight: 'var(--space-200)',
    minHeight: '40px'
  }, dsCommonStyles), {}, {
    '&::after': {
      marginLeft: 'var(--space-offset-50)',
      fontSize: 'var(--font-sizes-300)'
    }
  }),
  dsSm: _objectSpread(_objectSpread({
    paddingLeft: 'var(--space-100)',
    paddingRight: 'var(--space-100)',
    minHeight: '32px'
  }, dsCommonStyles), {}, {
    '&::after': {
      marginLeft: 'var(--space-offset-50)',
      fontSize: 'var(--font-sizes-200)'
    }
  })
};
var buttons = {
  variants: {
    dsPrimary: {
      color: designTokens.colors.buttons.dsPrimary.color.idle,
      background: designTokens.colors.buttons.dsPrimary.background.idle,
      ':hover': {
        background: designTokens.colors.buttons.dsPrimary.background.hover
      },
      ':active': {
        background: designTokens.colors.buttons.dsPrimary.background.active
      },
      ':focus': _objectSpread({}, outlines["default"])
    },
    dsTransparent: {
      background: designTokens.colors.buttons.dsTransparent.background.idle,
      color: designTokens.colors.buttons.dsTransparent.color.idle,
      border: "1px solid ".concat(designTokens.colors.buttons.dsTransparent.border.idle),
      ':hover': {
        background: designTokens.colors.buttons.dsTransparent.background.hover,
        borderColor: designTokens.colors.buttons.dsTransparent.border.hover
      },
      ':active': {
        background: designTokens.colors.buttons.dsTransparent.background.active,
        borderColor: designTokens.colors.buttons.dsTransparent.border.active
      },
      ':focus': _objectSpread({}, outlines["default"])
    },
    white: {
      background: designTokens.colors.buttons.white.background.idle,
      color: designTokens.colors.buttons.white.color.idle,
      border: "1px solid ".concat(designTokens.colors.buttons.white.border.idle),
      ':hover': {
        background: designTokens.colors.buttons.white.background.hover,
        borderColor: designTokens.colors.buttons.white.border.hover
      },
      ':active': {
        background: designTokens.colors.buttons.white.background.active,
        borderColor: designTokens.colors.buttons.white.border.hover
      },
      ':focus': _objectSpread({}, outlines["default"])
    },
    transparent: {
      background: designTokens.colors.buttons.transparent.background.idle,
      color: designTokens.colors.buttons.transparent.color.idle,
      border: "1px solid ".concat(designTokens.colors.buttons.transparent.border.idle),
      ':hover': {
        background: designTokens.colors.buttons.transparent.background.hover,
        borderColor: designTokens.colors.buttons.transparent.border.hover
      },
      ':active': {
        background: designTokens.colors.buttons.transparent.background.active,
        borderColor: designTokens.colors.buttons.transparent.border.active
      },
      ':focus': _objectSpread({}, outlines["default"])
    },
    transparentWhite: {
      background: designTokens.colors.buttons.transparentWhite.background.idle,
      color: designTokens.colors.buttons.transparentWhite.color.idle,
      border: "1px solid ".concat(designTokens.colors.buttons.transparentWhite.border.idle),
      ':hover': {
        background: designTokens.colors.buttons.transparentWhite.background.hover,
        borderColor: designTokens.colors.buttons.transparentWhite.border.hover
      },
      ':active': {
        background: designTokens.colors.buttons.transparentWhite.background.active,
        borderColor: designTokens.colors.buttons.transparentWhite.border.active
      },
      ':focus': _objectSpread({}, outlines["default"])
    },
    primary: {
      background: designTokens.colors.buttons.primary.background.idle,
      color: designTokens.colors.buttons.primary.color.idle,
      border: "1px solid ".concat(designTokens.colors.buttons.primary.border.idle),
      ':hover': {
        background: designTokens.colors.buttons.primary.background.hover,
        borderColor: designTokens.colors.buttons.primary.border.hover
      },
      ':active': {
        background: designTokens.colors.buttons.primary.background.active,
        borderColor: designTokens.colors.buttons.primary.border.active
      },
      ':focus': _objectSpread({}, outlines["default"])
    },
    secondary: {
      background: designTokens.colors.buttons.secondary.background.idle,
      color: designTokens.colors.buttons.secondary.color.idle,
      border: "1px solid ".concat(designTokens.colors.buttons.secondary.border.idle)
    },
    secondaryBlue: {
      background: designTokens.colors.buttons.secondaryBlue.background.idle,
      border: "1px solid ".concat(designTokens.colors.buttons.secondaryBlue.border.idle),
      color: designTokens.colors.buttons.secondaryBlue.color.idle,
      '&:hover': {
        background: designTokens.colors.buttons.secondaryBlue.background.hover
      },
      '&:active': {
        background: designTokens.colors.buttons.secondaryBlue.background.active
      },
      '&:focus': _objectSpread({}, outlines["default"])
    },
    dark: {
      background: designTokens.colors.buttons.dark.background.idle,
      color: designTokens.colors.buttons.dark.color.idle,
      border: "1px solid ".concat(designTokens.colors.buttons.dark.border.idle),
      transition: 'border-color ' + animation.transitionDuration,
      '&:hover': {
        background: designTokens.colors.buttons.dark.background.hover,
        borderColor: designTokens.colors.buttons.dark.border.hover
      },
      '&:active': {
        background: designTokens.colors.buttons.dark.background.active,
        borderColor: designTokens.colors.buttons.dark.border.active
      },
      '&:focus': _objectSpread({}, outlines["default"])
    },
    dropdown: {
      textAlign: 'left',
      color: designTokens.colors.buttons.dropdown.color.idle,
      background: designTokens.colors.buttons.dropdown.background.idle,
      borderWidth: '1px',
      borderStyle: 'solid',
      borderColor: designTokens.colors.buttons.dropdown.border.idle,
      borderRadius: 40,
      '&& > span': {
        paddingRight: 48,
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis'
      },
      '&:hover': {
        borderColor: designTokens.colors.buttons.dropdown.border.hover
      },
      '&:active, &[aria-expanded="true"]': {
        borderColor: designTokens.colors.buttons.dropdown.border.active
      }
    }
  },
  sizes: sizes,
  spacing: spacing,
  withArrowSpacing: withArrowSpacing
};
export default buttons;